import React, { useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import SignUpSuccessStyles from "./signUpSuccessStyle";
import Grid from "@material-ui/core/Grid";
import RedirectBtn from "./RedirectBtn/RedirectBtn";
import T from "Translate";
import Doodles from "Assets/svg/doodles.svg";
import MarketsSvc from "Services/markets/marketsSvc";

const SignUpSuccess = props => {
    const { classes, account, ...others } = props;
    const startOver = () => {
        window.location.reload();
    };

    useEffect(() => {
        window.scroll(0, 0);

        // Universal cookie didn't work
        document.cookie = "refId=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;";
    }, []);

    const Header = (
        <div className={classes.header}>
            <div className={classes.welcomeHeader} data-testid="success_title">
                <T>youre_a</T>{" "}
                <span className="member">
                    <T>member</T>
                    <img src={Doodles} alt="doodles" />
                </span>
            </div>
            <div className={classes.welcome} data-testid="success_subtitle">
                <T>welcome_unicity</T>
            </div>
        </div>
    );
    return (
        <div className={classes.root} style={{ direction: MarketsSvc.isRTL(props.language) ? "rtl" : "ltr" }}>
            {Header}
            <Grid item xs={12}>
                <Grid container justify="center">
                    <div className={classes.membershipID}>
                        <span data-testid="success_user_name">
                            {account.firstName} {account.lastName}
                        </span>{" "}
                        <span className="pipe" />{" "}
                        <span data-testid="success_membership_id">
                            <T>id</T> {props.membershipID}
                        </span>
                    </div>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid container justify="center">
                    <div className={classes.signUpDesc} data-testid="success_message">
                        <T>success_message</T>
                    </div>
                </Grid>
            </Grid>
            <div className={classes.button}>
                <RedirectBtn {...others} />
            </div>
            <Grid item xs={12}>
                <Grid container justify="center">
                    <div className={classes.signUpNewLink}>
                        <span data-testid="signup_another_person">
                            <T>signup_another_person</T>
                        </span>{" "}
                        <span onClick={startOver} data-testid="signup_another_person_link" id="another_sign_up">
                            {" "}
                            <T>click_here</T>
                        </span>
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default withStyles(SignUpSuccessStyles)(SignUpSuccess);



// WEBPACK FOOTER //
// ./src/components/SignUpSuccessContainer/SignUpSuccess/SignUpSuccess.js